angular.module("vouchers").classy.controller({
    name: "VouchersController",
    inject: [
        "$scope",
        "authServiceFactory",
        "VouchersModalService",
        "VouchersModelService",
        "VoucherOrderModelService",
        "FirstRunModalService",
        "VouStatementModelService",
        "ModelService",
        "DateService",
        "StandardCudService",
        "SchoolModelService",
        "VouchersModelService",
        "PaymentModalService"
    ],
    init: function() {
        this.$.date = new moment().year();
        this.FirstRunModalService.fireFirstRun("vouchers");
        this.$.DateService = this.DateService;
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.VouchersModalService = this.VouchersModalService;
        this.$.VouchersModelService = this.VouchersModelService;
        this.$.PaymentModalService = this.PaymentModalService;
        this.$.items = this.VouchersModelService.get();
        this.$.schoolID = this.authServiceFactory.getAuth().schoolID;
        this.$.orders = this.VoucherOrderModelService.get();
        this.$.paymentQuantity = 3;
        this.$.statementQuantity = 1;
        this.$.statements = this.VouStatementModelService.get();
        this.organizeOrders();
        this.$.years = [];
        this.$.anyAlliance = false;

        // Iterate through all vouchers
        for (let i = 0; i < this.$.items.length; i++) {
            let voucher = this.$.items[i];
            let label = {};
            // Get available years for dropdown
            let y = voucher.date_created.substring(0, 4);
            if (this.$.years.indexOf(y) === -1) {
                this.$.years.push(y);
            }
            // Determine if this school receives alliance vouchers
            if (!this.$.anyAlliance && Number(voucher.isAlliance) === 1) {
                this.$.anyAlliance = true;
            }
            // Prepare a formatted string for voucher family
            if (typeof voucher.App_Last === "string") {
                let trimmedAppLast = voucher.App_Last.trim();
                label.family = trimmedAppLast.length > 0 ? trimmedAppLast : "N/A";
            } else {
                label.family = voucher.App_Last || "N/A";
            }
            // Prepare a formatted string for voucher price
            if (typeof voucher.price === "string" && voucher.price.trim().length === 0) {
                label.price = "N/A";
            } else {
                label.price = "$" + Number.parseFloat(voucher.price).toFixed(2);
            }
            // Prepare a formatted string for voucher number
            if (typeof voucher.Voucher_Number === "string") {
                let trimmedVoucherNumber = voucher.Voucher_Number.trim();
                label.number = trimmedVoucherNumber.length > 0 ? trimmedVoucherNumber : "N/A";
            } else {
                label.number = voucher.Voucher_Number || "N/A";
            }
            // Append label to voucher
            this.$.items[i].label = label;
        }
        // Add a default year if existing years were not found
        if (!this.$.years.includes(this.$.date.toString())) {
            this.$.years.push(this.$.date.toString());
        }
        // Sort years (descending)
        this.$.years = this.$.years.sort((a, b) => b - a);
        // Set default filters
        this.$.filter = {
            year: this.$.years[0],
            used: true,
            outstanding: true,
            paid: true,
            unpaid: true,
            billable: true,
            free: true
        };
        if (this.$.anyAlliance) {
            this.$.filter.alliance = true;
        }
    },
    getSort: function() {
        let sort = [];

        if (this.$.anyAlliance) {
            sort.push("-isAlliance");
        }
        sort.push("-date_created");

        return sort;
    },
    organizeOrders: function() {
        this.$.orderHistory = [];
        for (let i = 0; i < this.$.orders.length; i++) {
            this.$.orderHistory[this.$.orders[i].recordID] = [];
            for (let j = 0; j < this.$.statements.length; j++) {
                if (this.$.orders[i].recordID == this.$.statements[j].OrderID) {
                    for (let k = 0; k < this.$.items.length; k++) {
                        if (this.$.items[k].StatementID == this.$.statements[j].VouStamentID
                            && this.$.items[k].Ap_Number != ""
                        ) {
                            this.$.orderHistory[this.$.orders[i].recordID].push(this.$.items[k]);
                        }
                    }
                }
            }
        }
    },
    showMorePayments: function() {
        this.$.paymentQuantity += 2;
    },
    showMoreStatements: function() {
        this.$.statementQuantity += 2;
    },
    momentD: function(date) {
        const dt = moment(date);
        return dt.format("MMM Do, YYYY");
    },
    momentDT: function(datetime) {
        const dt = moment(datetime);
        return dt.format("MMM Do, YYYY h:mm a");
    },
    momentSQL: function(datetime) {
        const dt = moment(datetime);
        return dt.format("YYYY-MM-D HH:mm:ss");
    },
    delete: function(item) {
        swal({
            title: "Are you sure?",
            text: "You will not be able to recover this voucher",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: false
        }, () => {
            this.VouchersModelService.purge(this.SchoolModelService.get()[0].schoolID, item).then(() => {
                swal("Deleted!", "The voucher has been deleted.", "success");
                this.$.items = this.VouchersModelService.get();
            });
        });
    },
    openModal: function(item) {
        this.VouchersModalService.initModal(item).result.then(() => { // Success
            this.$.items = this.VouchersModelService.get();
        },
        () => { // Dismiss
        });
    }
});
